import { resolveModuleFromPath } from '@/config/appNavigation';
import { isPlatformAdminRoute } from '@/config/moduleDefaults';
import { isGlobalWorkspaceRoute } from '@/constants/globalWorkspaceRoutes';

const OPEN_WORKSPACE_PREFIXES = ['/onboarding', '/dashboard/home', '/org/locked'];

/** Module app routes that must be registered in routeAccessRegistry. */
export function isGuardedModulePath(pathname: string): boolean {
  const path = pathname.split('?')[0];
  if (!path || path === '/') return false;
  if (OPEN_WORKSPACE_PREFIXES.some((p) => path === p || path.startsWith(`${p}/`))) {
    return false;
  }
  if (isPlatformAdminRoute(path)) return false;
  if (isGlobalWorkspaceRoute(path)) return false;
  return resolveModuleFromPath(path) != null;
}
